"use client";

import DynamicStats from "@/components/DynamicStats.js";
import OpportunitiesCardWrapper from "@/components/OpportunitiesCardWrapper";
import {
  RouteDealCard,
  BlogCard,
} from "@/components/featured/bus";

import {
  IconText,
  BrandCard,
} from "@/components/featured/common";

export const componentRegistry = {
  BrandCard,
  BlogCard,
  RouteDealCard,
  DynamicStats,
  IconText,
  OpportunitiesCardWrapper,
};

export const itemPropMapping = {
  OpportunitiesCardWrapper: "stats",
  BrandCard: "brand",
  BlogCard: "post",
  RouteDealCard: "item",
  DynamicStats: "stats",
};
